<template>
  <label class="switch">
    <input type="checkbox" class="switch-input" v-bind="$attrs" />
    <span class="switch-label"></span>
    <span class="switch-handle"></span>
  </label>
</template>
<script>
export default {
  inheritAttrs: false,
};
</script>
